import ShopOrderItemResourceListResultModel from '../../generated/types/model/resource/ShopOrderItemResourceListResultModel';

export default class ShopOrderItemResourceListResultViewModel extends ShopOrderItemResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
